module.exports = __webpack_public_path__ + "static/media/office2.6ca99f9c.jpg";